import { useEffect } from 'react'
import { useTelegram } from './use-telegram'
import { useRouter } from '@tanstack/react-router'

/**
 * Хук для управления BackButton в заголовке Telegram
 * 
 * @param enabled - Показывать ли кнопку "Назад"
 * @param customHandler - Кастомный обработчик (по умолчанию - router.history.back())
 * 
 * @example
 * ```tsx
 * // Автоматическая навигация назад
 * useBackButton(true)
 * 
 * // Кастомный обработчик
 * useBackButton(true, () => {
 *   if (hasUnsavedChanges) {
 *     showConfirmDialog()
 *   } else {
 *     router.navigate({ to: '/' })
 *   }
 * })
 * 
 * // Отключить на главной странице
 * useBackButton(false)
 * ```
 */
export function useBackButton(enabled: boolean = true, customHandler?: () => void) {
  const { BackButton, hapticFeedback } = useTelegram()
  const router = useRouter()

  useEffect(() => {
    if (!enabled) {
      BackButton.hide()
      return
    }

    const handleBack = () => {
      hapticFeedback.impactOccurred('light')
      
      if (customHandler) {
        customHandler()
      } else {
        router.history.back()
      }
    }

    BackButton.show()
    BackButton.onClick(handleBack)

    return () => {
      BackButton.offClick(handleBack)
      BackButton.hide()
    }
  }, [enabled, customHandler])
}

